export const environment = {
  production: false,
  BASE_URL: 'https://api.dev.gateway.zestpayment.com/payment-pages',
  ROOT_SERVICE_URL: 'https://api.dev.gateway.zestpayment.com/root',
  INVOICE_URL: 'https://api.dev.gateway.zestpayment.com/invoice',
  PRODUCT_URL: 'https://store.dev.gateway.zestpayment.com/stores',
  SETUP_ZEST_PROFILE_URL: 'https://business.dev.zestpayment.com',
  SDK_URL:
    'https://sdk.dev.gateway.zestpayment.com/paymentgatewaysdk/omni-payment-gateway-sdk-v3.0.0.js',
  ZESTPAYMENT_URL: 'https://api.dev.gateway.zestpayment.com/payment-engine',
  CMA_CGM_MERCHANT_ID: 'Z-1368654',
};
